import {TConnector } from '../model';
import { TIndexState, TUpsertISRProjectDataModelsInput } from "../model";

type useCategoryConfigurationUpdaterProps = {
  setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
}

const useConnectorConfigurationUpdater = ({ setUserProjectDataModels }: useCategoryConfigurationUpdaterProps) => {

  const updateConnectorConfiguration = (indexInfo: TIndexState, updatedConfig: TConnector, belongsToDataModel: boolean) => {
    console.log("🚀 ~ file: useConnectorConfigurationUpdater.ts:11 ~ updateConnectorConfiguration ~ belongsToDataModel:", belongsToDataModel)
    setUserProjectDataModels((prevDataModels) => {
      const newDataModels = { ...prevDataModels };
      if (belongsToDataModel) {
        // Update in the dataModels
        const dataModelToUpdate = newDataModels.project.dataModels[indexInfo.dataModelIndex ?? -1];
        if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.connectors[indexInfo.connectorIndex ?? -1]) {
          dataModelToUpdate.data.connectors[indexInfo.connectorIndex ?? -1] = updatedConfig;
        }
      } else {
        const fieldToUpdate = newDataModels.project.connectors[indexInfo.connectorOutsideDataModelIndex ?? -1];
        if (fieldToUpdate) {
          fieldToUpdate.type = updatedConfig.type;
          fieldToUpdate.data = updatedConfig.data;
        }
      }
      return newDataModels;
    });
  };
  

  return { updateConnectorConfiguration };
};

export default useConnectorConfigurationUpdater;